import { useCallback, useEffect, useState } from "react"
import dayjs from "dayjs"
import { makeStyles } from '@material-ui/core'

const CURRENT_YEAR = dayjs().year()

const XMAS = {
    from: dayjs(`${CURRENT_YEAR}-12-06 00:00:00`).unix(),
    to: dayjs(`${CURRENT_YEAR + 1}-01-05 23:59:59`).unix()
}

const VALENTINE = {
    from: dayjs(`${CURRENT_YEAR}-02-01 00:00:00`).unix(),
    to: dayjs(`${CURRENT_YEAR}-02-20 23:59:59`).unix()
}

const SONGKRAN = {
    from: dayjs(`${CURRENT_YEAR}-04-01 00:00:00`).unix(),
    to: dayjs(`${CURRENT_YEAR}-04-20 23:59:59`).unix()
}

const MOTHERS_DAY = {
    from: dayjs(`${CURRENT_YEAR}-08-01 00:00:00`).unix(),
    to: dayjs(`${CURRENT_YEAR}-08-20 23:59:59`).unix()
}

const HALLOWEEN = {
    from: dayjs(`${CURRENT_YEAR}-10-01 00:00:00`).unix(),
    to: dayjs(`${CURRENT_YEAR}-10-30 23:59:59`).unix()
}

const LOY_KRATHONG = {
    from: dayjs(`${CURRENT_YEAR}-11-01 00:00:00`).unix(),
    to: dayjs(`${CURRENT_YEAR}-11-20 23:59:59`).unix()
}

const FATHERS_DAY = {
    from: dayjs(`${CURRENT_YEAR}-12-01 00:00:00`).unix(),
    to: dayjs(`${CURRENT_YEAR}-12-05 23:59:59`).unix()
}

const useStyles = makeStyles((theme) => ({
    default: {
        height: 30,
        width: 166.55,
        cursor: 'pointer',
        [theme.breakpoints.only('md')]: {
            width: 130
        }
    },
    defaultResponsive: {
        width: 140,
        height: 25,
        cursor: 'pointer'
    },
    defaultFooter: {
        width: 200,
        margin: '1.5em 0px'
    },
    xmas: {
        height: 150,
        width: 190,
        cursor: 'pointer',
        [theme.breakpoints.only('md')]: {
            width: 130
        }
    },
    xmasResponsive: {
        width: 120,
        cursor: 'pointer'
    },
    xmasFooter: {
        width: 200,
    },
    valentine: {
        height: 150,
        width: 190,
        cursor: 'pointer',
        [theme.breakpoints.only('md')]: {
            width: 130
        }
    },
    valentineResponsive: {
        width: 120,
        cursor: 'pointer'
    },
    valentineFooter: {
        width: 200,
    },
    songkarn: {
        height: 150,
        width: 190,
        cursor: 'pointer',
        [theme.breakpoints.only('md')]: {
            width: 130
        }
    },
    songkarnResponsive: {
        width: 120,
        cursor: 'pointer'
    },
    songkarnFooter: {
        width: 200,
    },
    mothersDay: {
        height: 150,
        width: 190,
        cursor: 'pointer',
        [theme.breakpoints.only('md')]: {
            width: 130
        }
    },
    mothersDayResponsive: {
        width: 120,
        cursor: 'pointer'
    },
    mothersDayFooter: {
        width: 200,
    },
    halloween: {
        height: 90,
        width: 170,
        cursor: 'pointer',
        [theme.breakpoints.only('md')]: {
            width: 130
        }
    },
    halloweenResponsive: {
        width: 140,
        cursor: 'pointer'
    },
    halloweenFooter: {
        width: 200,
    },
    loyKrathong: {
        height: 150,
        width: 190,
        cursor: 'pointer',
        [theme.breakpoints.only('md')]: {
            width: 130
        }
    },
    loyKrathongResponsive: {
        width: 120,
        cursor: 'pointer'
    },
    loyKrathongFooter: {
        width: 200,
    },
}))

const BASE_PATH_IMAGE = '/static/img'

const useFestivalTheme = () => {
    const classes = useStyles()

    const [asset, setAsset] = useState({ 
        radius: [], 
        images: [], 
        logo: `${BASE_PATH_IMAGE}/sp-logo.svg`, 
        snowflakeCount: 0 
    })
    const [logoStyle, setLogoStyle] = useState({ 
        header: {
            className: classes.default, 
            classNameResponsive: classes.defaultResponsive 
        }, 
        footer: {
            className: classes.defaultFooter
        }
    })

    const handleMapLogo = useCallback((festivalName) => {
        let _asset = {}
        let _style = {}

        switch (festivalName) {
            case 'xmas':
                _asset = { 
                    radius: [2, 8], 
                    images: [], 
                    logo: `${BASE_PATH_IMAGE}/festivals/xmas/sp-xmas-logo.svg`, 
                    snowflakeCount: 70 
                }
                _style = {
                    header: {
                        className: classes.xmas, 
                        classNameResponsive: classes.xmasResponsive 
                    }, 
                    footer: {
                        className: classes.xmasFooter
                    }
                }
                break
            case 'valentine':
                _asset = {
                    radius: [10, 25], 
                    images: [
                        `${BASE_PATH_IMAGE}/festivals/valentine/sakura-leaft-1.png`,
                        `${BASE_PATH_IMAGE}/festivals/valentine/sakura-leaft-2.png`,
                        `${BASE_PATH_IMAGE}/festivals/valentine/sakura-leaft-3.png`,
                        `${BASE_PATH_IMAGE}/festivals/valentine/sakura-leaft-4.png`,
                        `${BASE_PATH_IMAGE}/festivals/valentine/sakura-leaft-5.png`
                    ], 
                    logo: `${BASE_PATH_IMAGE}/festivals/valentine/sp-valentine-logo.svg`,
                    snowflakeCount: 30
                }
                _style = {
                    header: {
                        className: classes.valentine, 
                        classNameResponsive: classes.valentineResponsive 
                    }, 
                    footer: {
                        className: classes.valentineFooter
                    }
                }
                break
            case 'songkran':
                _asset = {
                    radius: [],
                    images: [],
                    logo: `${BASE_PATH_IMAGE}/festivals/songkran/sp-songkran-logo.svg`,
                    snowflakeCount: 0
                }
                _style = {
                    header: {
                        className: classes.songkarn, 
                        classNameResponsive: classes.songkarnResponsive 
                    }, 
                    footer: {
                        className: classes.songkarnFooter
                    }
                }
                break
            case 'mothers_day':
                _asset = {
                    radius: [],
                    images: [],
                    logo: `${BASE_PATH_IMAGE}/festivals/mothers-day/sp-mothers-day-logo.svg`,
                    snowflakeCount: 0
                }
                _style = {
                    header: {
                        className: classes.mothersDay, 
                        classNameResponsive: classes.mothersDayResponsive 
                    }, 
                    footer: {
                        className: classes.mothersDayFooter
                    }
                }
                break
            case 'halloween':
                _asset = {
                    radius: [10, 25],
                    images: [
                        `${BASE_PATH_IMAGE}/festivals/halloween/maple-leaf-1.png`,
                        `${BASE_PATH_IMAGE}/festivals/halloween/maple-leaf-2.png`,
                        `${BASE_PATH_IMAGE}/festivals/halloween/maple-leaf-2.png`,
                        `${BASE_PATH_IMAGE}/festivals/halloween/maple-leaf-2.png`,
                    ],
                    logo: `${BASE_PATH_IMAGE}/festivals/halloween/sp-halloween-logo.png`,
                    snowflakeCount: 30
                }
                _style = {
                    header: {
                        className: classes.halloween, 
                        classNameResponsive: classes.halloweenResponsive 
                    },
                    footer: {
                        className: classes.halloweenFooter
                    }
                }
                break
            case 'loy_krathong':
                _asset = {
                    radius: [],
                    images: [],
                    logo: `${BASE_PATH_IMAGE}/festivals/loy-krathong/sp-loy-krathong-logo.svg`,
                    snowflakeCount: 0
                }
                _style = {
                    header: {
                        className: classes.loyKrathong, 
                        classNameResponsive: classes.loyKrathongResponsive 
                    },
                    footer: {
                        className: classes.loyKrathongFooter
                    }
                }
                break
            case 'fathers_day':
                _asset = {
                    radius: [],
                    images: [],
                    logo: `${BASE_PATH_IMAGE}/festivals/fathers-day/sp-fathers-day-logo.svg`,
                    snowflakeCount: 0
                }
                _style = {
                    header: {
                        className: classes.mothersDay, 
                        classNameResponsive: classes.mothersDayResponsive 
                    },
                    footer: {
                        className: classes.mothersDayFooter
                    }
                }
                break
            default:
                _asset = { 
                    radius: [], 
                    images: [], 
                    logo: `${BASE_PATH_IMAGE}/sp-logo.svg`, 
                    snowflakeCount: 0 
                }
                _style = { 
                    header: {
                        className: classes.default, 
                        classNameResponsive: classes.defaultResponsive 
                    }, 
                    footer: {
                        className: classes.defaultFooter
                    }
                }
                break
        }

        setAsset(_asset)
        setLogoStyle(_style)
    }, [])

    useEffect(() => {
        const current = dayjs().unix()
        let festivalName = null

        if (current > XMAS.from && current <= XMAS.to) {
            festivalName = 'xmas'
        } else if (current > VALENTINE.from && current <= VALENTINE.to) {
            festivalName = 'valentine'
        } else if (current > SONGKRAN.from && current <= SONGKRAN.to) {
            festivalName = 'songkran'
        } else if (current > MOTHERS_DAY.from && current <= MOTHERS_DAY.to) {
            festivalName = 'mothers_day'
        } else if (current > HALLOWEEN.from && current <= HALLOWEEN.to) {
            festivalName = 'halloween'
        } else if (current > LOY_KRATHONG.from && current <= LOY_KRATHONG.to) {
            festivalName = 'loy_krathong'
        } else if (current > FATHERS_DAY.from && current <= FATHERS_DAY.to) {
            festivalName = 'fathers_day'
        }

        handleMapLogo(festivalName)
    }, [])

    return { asset, logoStyle }
}

export default useFestivalTheme